<template>
  <v-col cols="12" xs="12" sm="6" md="6" lg="4" xl="3" v-for="riskIndicatorsGroup in statsStore.flagging.riskIndicatorsGroups">
    <RiskWidget :risk-indicators-group="riskIndicatorsGroup" />
  </v-col>
</template>

<script setup lang="ts">
import { useStatsStore } from "@/stores/statsStore";
import RiskWidget from "@/views/dashboard-view/RiskWidget.vue";

const statsStore = useStatsStore();
</script>